// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WiRnU","label":"styles_label__1i_-K"};